import React, { useEffect, useRef, useState } from 'react'
import { Button, message } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { PreviewFile } from './files'

export default function DownloadButton({ file }: { file: PreviewFile }) {
  const [loading, setLoading] = useState(false)
  const request = useRef<AbortController>()
  useEffect(() => () => request.current?.abort(), [])
  async function download() {
    const controller = new AbortController()
    request.current = controller
    setLoading(true)
    try {
      const response = await fetch(file.url, {
        signal: controller.signal,
        credentials: 'same-origin',
      })
      if (!response.ok) throw new Error('Download failed')
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = file.name
      document.body.appendChild(link)
      link.click()
      link.remove()
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    } catch {
      if (!controller.signal.aborted)
        message.error('Не удалось скачать файл. Откройте его в новой вкладке и сохраните оттуда.')
    } finally {
      if (!controller.signal.aborted) setLoading(false)
    }
  }
  return (
    <Button icon={<DownloadOutlined />} loading={loading} onClick={download}>
      Скачать
    </Button>
  )
}
